import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { Wrapper } from 'modules/Roles/ViewRole/CandidatesTable/CandidateFilter/Styles/style'
import React from 'react'

const CandidateStatusFilter = ({ candidateStatus, setCandidateStatus }) => {
  const statusOptions = [
    {
      label: 'Applied',
      value: 'ACTIVE',
    },
    {
      label: 'Shortlisted',
      value: 'SHORTLISTED',
    },
    {
      label: 'Rejected',
      value: 'REJECTED',
    },
    {
      label: 'Hold',
      value: 'HOLD',
    },
    {
      label: 'Pending',
      value: 'PENDING',
    },
  ]

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={candidateStatus}
        options={statusOptions}
        onChange={values => setCandidateStatus([values[values?.length - 1]])}
      />
    </Wrapper>
  )
}

export default CandidateStatusFilter
